import { render, staticRenderFns } from "./FormCheckboxCustom.vue?vue&type=template&id=0052b10f"
import script from "./FormCheckboxCustom.vue?vue&type=script&lang=js"
export * from "./FormCheckboxCustom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports